module.exports = "././assets/Images/intro-mobile-tenant.png";